import { mutatorAction } from "satcheljs";

import { ImportJobsStore } from "../store/ImportJobsStore";

export const showImportDialog =  mutatorAction("showImportDialog", (show: boolean) => {
    ImportJobsStore().dialogOpen = show;
});